import { render } from "./companyParameters.vue?vue&type=template&id=4e07dccf"
import script from "./companyParameters.vue?vue&type=script&lang=js"
export * from "./companyParameters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__